import React from 'react';

import { Button, ButtonGroup, InputAdornment, OutlinedInput } from '@mui/material';

import { debounce } from 'lodash';

import { ProductRequestsDialog } from '../../components/Dialogs/ProductRequestsDialog/ProductRequestsDialog';
import { ProductRequestsFiltersDialog } from '../../components/Dialogs/ProductRequestsFiltersDialog/ProductRequestsFiltersDialog';
import { OfferStatus, ShippingRegion, VenueListAccessRequetsFilter } from '../../graphql/API';
import { useListOfferQuery } from '../../hooks/reactQuery/useOfferQuery';
import Icons from '../../themes/icons';
import { AccessRequestPageView } from './AccessRequest';

type Props = {
  filters?: Partial<VenueListAccessRequetsFilter>;
  setFilters: React.Dispatch<
    React.SetStateAction<Partial<VenueListAccessRequetsFilter> | undefined>
  >;
  view: AccessRequestPageView;
  handleView: (val: AccessRequestPageView) => void;
};

export const ProductRequestsHeader: React.FC<Props> = ({
  filters,
  setFilters,
  view,
  handleView,
}) => {
  const [productRequestsHistoryDialog, setProductRequestsHistoryDialog] = React.useState(false);
  const [productRequestsFiltersDialog, setProductRequestsFiltersDialog] = React.useState(false);

  const handleProductRequestsHistoryDialog = () => {
    setProductRequestsHistoryDialog((prev) => !prev);
  };

  const handleProductRequestsFiltersDialog = () => {
    setProductRequestsFiltersDialog((prev) => !prev);
  };

  const onHandleFilterChange = (filters: Partial<VenueListAccessRequetsFilter> | undefined) => {
    setFilters(filters);
  };

  const handleSearch = debounce((value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      searchText: value,
    }));
  }, 500);

  const isAnyFilterActive = React.useCallback(
    (filters: Partial<VenueListAccessRequetsFilter> | undefined) => {
      return (
        filters &&
        ((filters['minFollowers'] && filters['minFollowers'] > 0) ||
          ((filters['marketRegions'] && filters['marketRegions']?.length) || 0) > 0 ||
          filters['rating'] !== undefined ||
          filters['instagramVerified'] !== undefined)
      );
    },
    [],
  );

  return (
    <>
      <ButtonGroup variant='outlined' size='medium'>
        <Button
          sx={{
            border: '1px solid #EFEEEE',
            ...(view === 'grid' && { color: '#765BC6', backgroundColor: '#F1EFF9' }),
          }}
          onClick={() => handleView('grid')}
        >
          <Icons.GridIconV2 />
        </Button>
        <Button
          sx={{
            border: '1px solid #EFEEEE',
            ...(view === 'list' && { color: '#765BC6', backgroundColor: '#F1EFF9' }),
          }}
          onClick={() => handleView('list')}
        >
          <Icons.ListIconV2 />
        </Button>
      </ButtonGroup>

      <Button
        id='btn-filter'
        startIcon={
          <Icons.TuneOutlinedIcon htmlColor={isAnyFilterActive(filters) ? '#765BC6' : ''} />
        }
        onClick={handleProductRequestsFiltersDialog}
        sx={{ border: '1px solid #EFEEEE', px: 1.5, py: 0.2 }}
      >
        <span style={{ color: isAnyFilterActive(filters) ? '#765BC6' : '' }}>Filters</span>
      </Button>

      <Button
        id='btn-history'
        startIcon={<Icons.HistoryIcon />}
        onClick={handleProductRequestsHistoryDialog}
        sx={{ border: '1px solid #EFEEEE', px: 1.5, py: 0.2 }}
      >
        History
      </Button>

      <OutlinedInput
        id='outlined-adornment-amount'
        placeholder='Search a member...'
        startAdornment={
          <InputAdornment position='start'>
            <Icons.SearchIcon />
          </InputAdornment>
        }
        onChange={(e) => {
          handleSearch(e.target.value);
        }}
        size='small'
        sx={{ minWidth: '290px', border: '1px solid #EFEEEE' }}
      />

      <ProductRequestsDialog
        open={productRequestsHistoryDialog}
        onClose={handleProductRequestsHistoryDialog}
      />

      <ProductRequestsFiltersDialog
        open={productRequestsFiltersDialog}
        onClose={handleProductRequestsFiltersDialog}
        filters={filters}
        onFilterChange={onHandleFilterChange}
      />
    </>
  );
};
